import { Ativo, Variavel, buscarAtivos, buscarLeituras, buscarVariaveis } from "../api/m5";
import { renderAssetsMap } from "../components/map/assetsMap";
import { detalhesCarregando, detalhesErro, montarConteudoDetalhes, ultimaLeituraPorVariavel } from "../components/map/estacaoDetalhes";
import { WhitelabelConfig } from "../config/whitelabel";

export async function montarMapa(
  container: HTMLElement,
  config: WhitelabelConfig,
  layerAccess: string[] = []
): Promise<void> {
  container.innerHTML = `
    <div class="card" style="position: relative;">
      <div id="mapa-canvas" style="height: 560px;"></div>
      <div id="mapa-carregando" class="construcao" style="position:absolute; inset:0; background:var(--color-surface,#fff);">
        <p>Carregando mapa…</p>
      </div>
      <div id="mapa-painel-estacao" class="mapa-painel-estacao">
        <button class="mapa-painel-estacao__fechar" id="mapa-painel-fechar" aria-label="Fechar">&times;</button>
        <div id="mapa-painel-conteudo"></div>
      </div>
    </div>
  `;

  const [ativos, variaveis]: [Ativo[], Variavel[]] = await Promise.all([
    buscarAtivos().catch(() => []),
    buscarVariaveis().catch(() => []),
  ]);
  const el = container.querySelector("#mapa-canvas") as HTMLElement;
  const carregandoEl = container.querySelector("#mapa-carregando") as HTMLElement;

  if (ativos.every((a) => !a.geom)) {
    container.querySelector(".card")!.outerHTML =
      '<div class="construcao"><p>Nenhum ativo com geometria cadastrada ainda.</p></div>';
    return;
  }

  const painelEl = container.querySelector("#mapa-painel-estacao") as HTMLElement;
  const painelConteudoEl = container.querySelector("#mapa-painel-conteudo") as HTMLElement;

  function fecharPainel(): void {
    painelEl.classList.remove("mapa-painel-estacao--aberto");
  }

  async function abrirPainel(ativo: Ativo): Promise<void> {
    painelEl.classList.add("mapa-painel-estacao--aberto");
    painelConteudoEl.innerHTML = detalhesCarregando(ativo.nome);
    try {
      const leituras = await buscarLeituras({ assetIds: [ativo.id], limit: 300 });
      const ultimas = ultimaLeituraPorVariavel(leituras);
      painelConteudoEl.innerHTML = montarConteudoDetalhes(ativo.nome, ultimas, variaveis);
    } catch {
      painelConteudoEl.innerHTML = detalhesErro(ativo.nome);
    }
  }

  container.querySelector("#mapa-painel-fechar")!.addEventListener("click", fecharPainel);

  const mapa = renderAssetsMap(el, config, ativos, layerAccess, (ativo) => void abrirPainel(ativo));
  // Clique em area vazia do mapa (fora de qualquer marcador) fecha o painel -
  // marcadores ficam em overlay proprio do MapLibre, entao clique neles nao
  // dispara este evento (sem risco de fechar o painel que acabou de abrir).
  mapa.on("click", fecharPainel);
  mapa.on("load", () => carregandoEl.remove());
  // MapLibre precisa recalcular o tamanho depois do container ja estar no layout final
  setTimeout(() => mapa.resize(), 100);
}
